import qs from 'qs';
import { PartRequestByLineFilters } from '../stock/stock-part-requests/types/stockPartRequestTypes';
import {
  AxiosDataListResponse, AxiosNullableResponse, AxiosSingleResponse,
} from '../core/types/coreTypes';
import instance from './axiosConfig';
import {
  BulkEditLocationRequest, BulkEditLocationResponse, BulkEditOwnerRequest, BulkEditOwnerResponse,
  PartRequestBulkItemDto,
  PartRequestBulkOptions,
  PartRequestBulkSelectionRequest,
  PartRequestBulkSelectionResponse, PartRequestSubmitBulkResponse,
} from '../stock/stock-bulk/types';
import { BulkRequestTypeEnum } from '../stock/stock-bulk/BulkRequestTypeEnum';

export const stockBulkApi = {

  // Create new stock bulk operation for the current user
  createBulkOperation(operation: BulkRequestTypeEnum, filters: PartRequestByLineFilters): AxiosNullableResponse {
    return instance.post(`/stock/partRequests/lines/views/partRequestByLine/bulk/${operation}`, filters);
  },

  // Retrieve records for the current bulk operation
  fetchBulkRecords(
    filters: PartRequestByLineFilters,
    signal?: AbortSignal,
  ): AxiosDataListResponse<PartRequestBulkItemDto[], PartRequestBulkOptions> {
    return instance.get('/stock/partRequests/lines/views/partRequestByLine/bulk', {
      params: {
        'Filter.Keyword': filters.keyword,
        'Filter.ProductNumber': filters.productNumber,
        'Filter.LinkedEntityNumber': filters.linkedEntityNumber,
        'Filter.LinkedEntityStatus': filters.linkedEntityStatus,
        'Filter.Statuses': filters.statuses,
        'Filter.IsActive': filters.isActive,
        'PagingOptions.Page': filters.page,
        'PagingOptions.ItemsPerPage': filters.pageSize,
      },
      paramsSerializer: (params: unknown) => {
        return qs.stringify(params, { arrayFormat: 'repeat' });
      },
      signal,
    });
  },

  // Update user selection for the bulk operation
  updateSelection(request: PartRequestBulkSelectionRequest): AxiosSingleResponse<PartRequestBulkSelectionResponse> {
    return instance.post('/stock/partRequests/lines/views/partRequestByLine/bulk/selection', request);
  },

  // Update record location field value
  updateLocation(request: BulkEditLocationRequest): AxiosSingleResponse<BulkEditLocationResponse> {
    return instance.post('/stock/partRequests/lines/views/partRequestByLine/bulk/location', request);
  },

  // Update record owner field value
  updateOwner(request: BulkEditOwnerRequest): AxiosSingleResponse<BulkEditOwnerResponse> {
    return instance.post('/stock/partRequests/lines/views/partRequestByLine/bulk/owner ', request);
  },

  // Submit bulk operation
  submitBulkOperation(operation: BulkRequestTypeEnum): AxiosSingleResponse<PartRequestSubmitBulkResponse> {
    return instance.post(`/stock/partRequests/lines/views/partRequestByLine/bulk/${operation}/submit`, {});
  },

};
